module.exports = __webpack_public_path__ + "static/media/ReitzTeaUrn1.b1f46cfc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Reitz/ReitzTeaUrn1.jpg
// module id = 5763
// module chunks = 0